import styled from 'styled-components';
import Card from 'common/components/Card';
import { Metrics } from '../../../themes';

export const StyledContainer = styled.div`
  min-height: calc(100vh - ${Metrics.navBarHeight}px);
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: ${Metrics.margin}px;
  position: relative;
`;

export const Wrapper = styled.div`
  width: 90%;
  height: 80%;
`;

export const ReachCard = styled(Card) `
  flex-direction: column;
  display: flex;
  flex: 1;
`;

export const GraphWrapper = styled.div`
  position: relative;
  margin: ${Metrics.margin}px;
  margin-top: ${Metrics.largeMargin}px;

  height: 450px;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/components/styles.js